import { render, staticRenderFns } from "./confirm-email.vue?vue&type=template&id=128cb972&scoped=true&"
import script from "./confirm-email.vue?vue&type=script&lang=tsx&"
export * from "./confirm-email.vue?vue&type=script&lang=tsx&"
import style0 from "./confirm-email.vue?vue&type=style&index=0&id=128cb972&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128cb972",
  null
  
)

export default component.exports